module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerCommon",
    class: {
      noFooter: !this.IsShowFooter
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsShowFooter),
      expression: "IsShowFooter"
    }],
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-box"
  }, [_c('div', {
    staticClass: "box_left"
  }, [_c('div', {
    staticClass: "footer-box-top"
  }, [_c('div', {
    staticClass: "footer-top-div"
  }, [_c('div', {
    staticClass: "footer-top-con clearfix cp",
    on: {
      "click": _vm.goConsult
    }
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "footer-con-title"
  }, [_vm._v("需求咨询")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-top-div"
  }, [_c('div', {
    staticClass: "footer-top-con clearfix cp",
    on: {
      "click": function($event) {
        return _vm.goMore('footer-yuyueyanshi')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('h1', {
    staticClass: "footer-con-title"
  }, [_vm._v("预约演示")])])]), _vm._v(" "), _c('a', {
    staticClass: "footer-top-div",
    attrs: {
      "href": _vm.goHelp()
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('a', {
    staticClass: "footer-top-div",
    attrs: {
      "href": _vm.goDown()
    }
  }, [_vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "footer-box-bottom"
  }, [_c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.footer[0].name))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-left"
  }, _vm._l((_vm.footer[0].s.slice(0, 7)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-msg"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '1'),
        expression: "item.status === '1'"
      }],
      staticClass: "msg-content",
      attrs: {
        "href": _vm.getRooterLink(item.name, item.link)
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, _vm._l((_vm.footer[0].s.slice(-5)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-msg"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '1'),
        expression: "item.status === '1'"
      }],
      staticClass: "msg-content",
      attrs: {
        "href": _vm.getRooterLink(item.name, item.link)
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.footer[1].name))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-left"
  }, _vm._l((_vm.footer[1].s.slice(0, 6)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-msg"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '1'),
        expression: "item.status === '1'"
      }],
      staticClass: "msg-content",
      attrs: {
        "href": _vm.getRooterLink(item.name, item.link)
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, _vm._l((_vm.footer[1].s.slice(-5)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-msg"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '1'),
        expression: "item.status === '1'"
      }],
      staticClass: "msg-content",
      attrs: {
        "href": _vm.getRooterLink(item.name, item.link)
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.footer[2].name))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-left"
  }, _vm._l((_vm.footer[2].s), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-msg"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '1'),
        expression: "item.status === '1'"
      }],
      staticClass: "msg-content",
      on: {
        "click": function($event) {
          return _vm.goRooter(item.name, item.link)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.footer[3].name))]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-left"
  }, _vm._l((_vm.footer[3].s), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-msg"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '1'),
        expression: "item.status === '1'"
      }],
      staticClass: "msg-content",
      attrs: {
        "href": _vm.getRooterLink(item.name, item.link)
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), (_vm.linkShow) ? _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v("友情连接")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-left"
  }, _vm._l((_vm.linkData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "detail-msg"
    }, [_c('a', {
      staticClass: "msg-content",
      attrs: {
        "href": item.url,
        "rel": "external nofollow",
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box_right"
  }, [_c('div', {
    staticClass: "right_msg"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('p', {
    staticClass: "footer-tel-p"
  }, [_vm._v("\n              客服电话：\n              " + _vm._s(_vm.QRcode.mobile) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "footer-tel-p"
  }, [_vm._v("\n              商务合作：\n              " + _vm._s(_vm.QRcode.email) + "\n            ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.$global.globalPath + _vm.QRcode.src),
      expression: "$global.globalPath + QRcode.src"
    }],
    staticClass: "footer-img",
    attrs: {
      "alt": _vm.QRcode.title
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "detail-msg detail-text"
  }, [_vm._v(_vm._s(_vm.QRcode.title))])])])])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-con-img"
  }, [_c('img', {
    staticClass: "footer-img-detail",
    attrs: {
      "src": require("../../assets/img/index/icon_footer_phone.svg"),
      "alt": "需求咨询"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-con-img"
  }, [_c('img', {
    staticClass: "footer-img-detail",
    attrs: {
      "src": require("../../assets/img/index/icon_footer_demonstrate.svg"),
      "alt": "预约演示"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-top-con clearfix cp"
  }, [_c('div', {
    staticClass: "footer-con-img"
  }, [_c('img', {
    staticClass: "footer-img-detail",
    attrs: {
      "src": require("../../assets/img/index/icon_footer_help.svg"),
      "alt": "支持帮助"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "footer-con-title"
  }, [_vm._v("支持帮助")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-top-con clearfix cp"
  }, [_c('div', {
    staticClass: "footer-con-img"
  }, [_c('img', {
    staticClass: "footer-img-detail",
    attrs: {
      "src": require("../../assets/img/index/icon_download.svg"),
      "alt": "资料下载"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "footer-con-title"
  }, [_vm._v("资料下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "dib"
  }, [_vm._v("Copyright © 2017.上海甄云信息科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "dib ml30 footer-a"
  }, [_c('a', {
    staticClass: "dib ml30",
    attrs: {
      "href": "http://www.beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("沪ICP备18039109号-4")]), _vm._v(" "), _c('a', {
    staticClass: "dib ml30",
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011802002961",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/index/beian-icon.png")
    }
  }), _vm._v("沪公网安备31011802002961号\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://webcert.cnmstl.net/cert/grade?sn=2c1611bab21711ea9e3300163e068ceb",
      "target": "_blank",
      "id": "jvs-cert"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dib ml30"
  }, [_vm._v("\n        使用条款 客户隐私政策\n        "), _c('span', {
    attrs: {
      "id": "cnzz_stat_icon_1278721967"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-706d4829"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer.vue
// module id = 281
// module chunks = 12